'use strict';

import {SectionCtrl} from "./sectionctrl.js";
import {participantModel} from "../../models/participantmodel.js";

export class SectionA3ParticipantsCtrl extends SectionCtrl
{
	text = {
		before: {
			key: 'a3_participants_before',
			on: false,
			value: null
		},
		after: {
			key: 'a3_participants_after',
			on: false,
			value: null
		}
	};

	participants = [];
	isSaved = true;
	$mdDialog;

	constructor($scope, $filter, jsDataService, $mdDialog){
		super($scope, $filter, jsDataService);
		this.$mdDialog = $mdDialog;
//		console.log('jsDataService', jsDataService)
		if(typeof(this.section.participants) !== 'undefined'){
			this.initParticipants(this.section.participants);
		}
	}

	$onInit(){
		if(typeof(this.section.instructions) !== 'undefined'){
			for(let prop in this.text){
				if(typeof(this.section.instructions[this.text[prop].key]) !== 'undefined' && this.section.instructions[this.text[prop].key].value !== ''){
					this.text[prop].on = true;
					this.text[prop].value = this.section.instructions[this.text[prop].key].value;
				}
			}
		}
	}

	initParticipants(participants) {
		this.participants = [];
		const fields = this.jsDataService.data.sectionItem.fields;
		let affilitatedEntityActive = false;

		if (Array.isArray(fields)) {
			const assocField = fields.find(field => field.name === 'a3_participants_associated_partner');

			if (assocField && (assocField.active === true || assocField.active === "1")) {
				affilitatedEntityActive = true;
			}
		}
		for (let participant of participants) {
			if (affilitatedEntityActive && participant.a3_participants_role==4) {
				participant.a3_participants_role = "";
				participant.a3_participants_role_display = "";
			}
			this.participants.push(new participantModel(participant, this.$filter, this.jsDataService));
		}
	}


    participantPreview(e, item){
        let fields = [];
        if (this.section && Array.isArray(this.section.fields)) {
            fields = angular.copy(this.section.fields);
        }

        const roleNum = parseInt(item.a3_participants_role, 10) || 0;
        const hasAff = !!(item.a3_participants_affiliated || item.a3_participants_parent_beneficiary);
        const hasVat = !!(item.a3_participants_vat_number && String(item.a3_participants_vat_number).trim() !== '');

        const idxVatRec = fields.findIndex(f => f.name === 'a3_participants_vat_recoverable');
        if (idxVatRec > -1 && (item.a3_participants_vat_recoverable_display || item.a3_participants_vat_recoverable_title)) {
            const fld = angular.copy(fields[idxVatRec]);
            fld.name = item.a3_participants_vat_recoverable_display ? 'a3_participants_vat_recoverable_display' : 'a3_participants_vat_recoverable_title';
            fields[idxVatRec] = fld;
        }

        if (roleNum !== 1) {
            fields = this.$filter('filter')(fields, {name: '!a3_participants_representative_name'}, true);
            fields = this.$filter('filter')(fields, {name: '!a3_participants_representative_phone'}, true);
            fields = this.$filter('filter')(fields, {name: '!a3_participants_representative_email'}, true);
        }
        if (roleNum !== 4 && !hasAff) {
            fields = this.$filter('filter')(fields, {name: '!a3_participants_affiliated'}, true);
        }
        if (!hasVat && idxVatRec > -1) {
            fields = this.$filter('filter')(fields, {name: '!a3_participants_vat_recoverable_display'}, true);
            fields = this.$filter('filter')(fields, {name: '!a3_participants_vat_recoverable_title'}, true);
            fields = this.$filter('filter')(fields, {name: '!a3_participants_vat_recoverable'}, true);
        }
        fields = this.$filter('filter')(fields, {name: '!a3_participants_associated_partner'}, true);

        const normalized = angular.copy(item);
        if ((!normalized.a3_participants_affiliated || normalized.a3_participants_affiliated === '') && normalized.a3_participants_parent_beneficiary) {
            normalized.a3_participants_affiliated = normalized.a3_participants_parent_beneficiary;
        }
        const parentId = String(normalized.a3_participants_affiliated || '');
        if (parentId) {
            const parent = this.participants.find(p => String(p.id) === parentId);
            if (parent && parent.a3_participants_name) {
                normalized.a3_participants_affiliated = parent.a3_participants_name;
            }
        }

        this.$mdDialog.show({
            controller: "ItemPreviewCtrl",
            controllerAs: "dctrl",
            templateUrl: 'esfasi/item_preview.html',
            parent: angular.element(document.body),
            targetEvent: e,
            clickOutsideToClose:true,
            fullscreen: true,
            multiple: true,
            locals: {
                item: normalized,
                options: { fields: fields }
            }
        }).then(function(){}, function(){});
    }


	loadData(){
		const url = this.jsDataService.get('cfgDataUrl');
		if(url){
			this.promise = this.$scope.basicHttpConfigProcess({
				url: url,
				method: 'GET',
				params: {}
			}).then((response) => {
				if(response.data.success){
					this.setData(response.data.data);
				}
			}, () => {});
		}
	}

	setData(data){
		this.participants = [];
		for(let row of data){
			this.participants.push(new participantModel(row, this.$filter, this.jsDataService));
		}
	}

	removeParticipant(ev, participant){
		if(this.jsDataService.get('cfgRemoveUrl', '') !== ''){
			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgRemoveUrl'),
					method: 'GET',
					responseType: 'json',
					params: {
						id: participant.id
					}
				}).then((results) => {
					if(results.data.success){
						this.loadData();
					}
				});
			}, () => {});
		}
	}

	editParticipant(ev, participant){
		this.participantEditor(ev, participant);
	}

	addParticipant(ev){
		this.participantEditor(ev, new participantModel({id: 0}, this.$filter, this.jsDataService));
	}

	participantEditor(ev, participant){
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "$filter", "$http", "jsDataService", "participant", "allparticipants", "fieldCfg", this.participantEditorDialogCtrl],
			templateUrl: 'application/participant_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				participant: participant,
				allparticipants: this.participants,
				fieldCfg: this.fieldCfg
			}
		}).then((results) => {
//			console.log('dialog close', results);
			if(this.jsDataService.get('cfgSaveUrl')){
				this.isSaved = false;
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgSaveUrl'),
					method: 'POST',
					data: {
						participant: results.participant
					}
				}).then((response) => {

					if(response.data.success){
						this.loadData();
					}
					this.isSaved = true;

				}, () => {});
			}
			else{
				console.log('no url ', this.jsDataService.get('cfgSaveUrl'));
			}
		}, () => {});
	}

	participantEditorDialogCtrl($scope, $mdDialog, $filter, $http, jsDataService, participant, allparticipants, fieldCfg){
		$scope.participant = angular.copy(participant);
		$scope.participant.participant_id = $scope.participant.id;
		$scope.isSearch = (typeof($scope.participant.id) === 'undefined' || $scope.participant.id < 1);
		$scope.classif = angular.copy(jsDataService.get('cfgClassif', {}));
		const fields = jsDataService.data.sectionItem.fields;
		let affilitatedEntityActive = false;
		if (Array.isArray(fields)) {
			const assocField = fields.find(field => field.name === 'a3_participants_associated_partner');
			if (assocField && (assocField.active === true || assocField.active === "1")) {
				affilitatedEntityActive = true;
			}
		}
		if(affilitatedEntityActive){
			$scope.classif.application_role = $scope.classif.application_role.filter(item => item.id !== '4'); //Affilitated Entity
		}
		$scope.classif.legalstatus.push({
			id: 'oth',
			active: '1',
			title: $filter('tr')('other')
		});

		$scope.allparticipants = angular.copy(allparticipants);
		$scope.beneficiary = [];
		$scope.idCodePattern = null;

		for(let i=0; i<$scope.allparticipants.length; i++){
			if($scope.allparticipants[i].id == $scope.participant.id){
				$scope.allparticipants[i] = $scope.participant;
				break;
			}
		}

		if(typeof($scope.participant.a3_participants_role) === 'undefined' && $scope.participant.participant_id < 1){
			$scope.participant.a3_participants_role = ($scope.allparticipants.length > 0) ? "2" : "1";
		}

		$scope.hasCoordinator = function(){
			return ($filter('filter')($scope.allparticipants, {a3_participants_role: '1'}, true).length > 0);
		};

		$scope.showRepresentative = function(){
			return ($scope.participant.a3_participants_role == '1');
		};

//		$scope.isCoordinator = false;
//
//		let coordinator = $filter('filter')($scope.allparticipants, {a3_participants_role: '1'});
//		if(coordinator.length > 0){
//			$scope.isCoordinator = true;
//		}
//		if(!$scope.isCoordinator && $scope.participant.id<1){
//			$scope.participant.a3_participants_role = "1";
//		}

		$scope.getClassif = function(name){
			if(typeof($scope.classif[name]) === 'undefined'){
				return [];
			}
			if(typeof($scope.classif[name][0].active) === 'undefined'){
				return $scope.classif[name];
			}
			return $filter('filter')($scope.classif[name], {active: 1});
		};

		let bnf = $filter('filter')($scope.allparticipants, {a3_participants_role: '!4'});
		if(bnf.length > 0){
			$scope.beneficiary = bnf;
		}
		$scope.fieldCfg = fieldCfg;

		$scope.isField = function (name){
			return (typeof(fieldCfg[name]) !== 'undefined');
		};

		$scope.getFieldLimit = function(name){
			if(!$scope.isField(name)){
				return null;
			}
			if(!fieldCfg[name].limitOn){
				return null;
			}
			return fieldCfg[name].limit;
		};

		$scope.setIdCodePattern = function(){
			let lim = $scope.getFieldLimit('a3_participants_id_code');
			let str = '[0-9]' + ((lim) ? '{1,' + lim + '}'  : '+');
			$scope.idCodePattern = new RegExp("^"+str+"$");
		};

		$scope.setIdCodePattern();

		$scope.vatvalueChanged = function(){
			$scope.fieldCfg.a3_participants_vat_recoverable.mandatory = ($scope.participant.a3_participants_vat_number && $scope.participant.a3_participants_vat_number !== '');
		};
		$scope.vatvalueChanged();

		$scope.close = function() {
			$mdDialog.cancel();
		};

		$scope.save = function(){
			$scope.participant.a3_participants_legal_status = [];
			let legal_statuses = $filter('filter')($scope.participant.legal_status, {id: '!oth'});
			for(let lsid of legal_statuses){
				$scope.participant.a3_participants_legal_status.push(lsid.id);
			}
			$mdDialog.hide({participant:$scope.participant.getData()});

		};

		$scope.legalStatusChange = function(){
			if($scope.participant.legal_status && $scope.participant.legal_status.length > 0){
				let oth = $filter('filter')($scope.participant.legal_status, {id: 'oth'});
				if(oth.length > 0){
					$scope.legalStatusOther(true);
				}
				else{
					$scope.legalStatusOther(false);
				}
			}
			else{
				$scope.legalStatusOther(false);
			}
		};

		$scope.legalStatusOther = function(on){
			$scope.participant.a3_participants_legal_status_other = !!on;
			if($scope.participant.a3_participants_legal_status_other){
				if(arguments[1]){
					$scope.participant.a3_participants_legal_status_other = arguments[1];
				}
			}
			else{
				$scope.participant.a3_participants_legal_status_other_value = '';
			}
		};

		$scope.isNumber = function(){
			return (typeof($scope.participant) !== 'undefined' && $scope.participant.a3_participants_reg_number && $scope.participant.a3_participants_reg_number !== '');
		};

		$scope.autoFill= function (e){
			const url = jsDataService.get('companyFindUrl', '');

			if($scope.isNumber() && url !== ''){
				$scope.searchNow = true;
				let rqq = $http({
					url: url,
					method: 'GET',
					responseType: 'json',
					params: {
						registration_number: $scope.participant.a3_participants_reg_number
					}
				});
				$scope.$root.onlyHttpProcess(rqq).then((response) => {
					$scope.searchNow = false;
					if(response.data && response.data.success){
						delete response.data.data.id;
						let data = {
							a3_participants_reg_number: response.data.data.registration_number,
							a3_participants_address: response.data.data.address,
							a3_participants_email: response.data.data.email,
//							a3_participants_representative_phone: response.data.data.phone,
							a3_participants_postcode: response.data.data.postcode,
							a3_participants_region: response.data.data.region,
							a3_participants_name: response.data.data.title,
							a3_participants_country_id: response.data.data.country_id,
							a3_participants_town: response.data.data.city,
							a3_participants_legal_status_other: response.data.data.legal_status_other,
							a3_participants_legal_status_other_value: response.data.data.legal_status_other_value,
							a3_participants_legal_status: response.data.data.legal_status_ids,
							a3_participants_vat_number: response.data.data.vat_number,
							a3_participants_vat_recoverable: response.data.data.vat_recoverable,
							a3_participants_web: response.data.data.website
						};
						if($scope.participant.id>0){
							data.id  = $scope.participant.id;
						}
						data.a3_participants_role = $scope.participant.a3_participants_role;
						data.a3_participants_associated_partner = $scope.participant.a3_participants_associated_partner;
//						$scope.participant = new participantModel(angular.extend($scope.participant.getData(), data));
						$scope.participant = new participantModel(data);
						$scope.participantLegalStatus();
						$scope.legalStatusChange();
						$scope.vatvalueChanged();
					}
				}, () => $scope.searchNow = false);
			}
		};

		$scope.participantLegalStatus = function(){
			$scope.participant.legal_status = [];

			let statuses = Array.isArray($scope.participant.a3_participants_legal_status)
				? $scope.participant.a3_participants_legal_status.slice()
				: [];

			if (
				$scope.participant.a3_participants_legal_status_other
				&& $scope.participant.a3_participants_legal_status_other_value
				&& $scope.participant.a3_participants_legal_status_other_value.trim() !== ''
			) {
				if (statuses.indexOf('oth') < 0) {
					statuses.push('oth');
				}
			}

			statuses.forEach(lsid => {
				let found = $filter('filter')(
					$scope.classif.legalstatus,
					{id: lsid},
					true
				);
				if (found.length) {
					$scope.participant.legal_status.push(found[0]);
				}
			});
		};
		$scope.participantLegalStatus();

	}


}

